<style>
  .gridHand {
    margin: 0;
    padding: 0;
  }

  .gridWrapper {
    width: 118px;
    height: 145px;
    display: grid;
    margin: auto;
    grid-template-columns: 41px 41px 41px;
    grid-template-rows: 50px 50px 50px;
    border-width: 3px;
    border-style: solid;
    border-color: transparent;
    -webkit-transition: border 1000ms ease-out;
    -moz-transition: border 1000ms ease-out;
    -o-transition: border 1000ms ease-out;
    transition: border 1000ms ease-out;
  }

  .playerTurn {
    border-color: green;
  }

  .notPlayerTurn {
    border-color: white;
  }

  .container {
    width: 41px;
    height: 46px;
  }

  .hand-cards {
    width: 33.6px;
    height: 43.2px;
    border: 1px solid black;
    background-repeat: no-repeat;
    background-size: auto 79px;
  }
  .hand-card-back {
    width: 33.6px;
    height: 43.2px;
    border: 1px solid black;
    background-repeat: no-repeat;
    background-size: cover;
  }

  .deckContainer {
    width: 106px;
    height: 58px;
    display: grid;
    margin: 15px auto;
    grid-template-columns: 48px 10px 48px;
  }

  .decks {
    height: 58px;
  }

  .game-cell {
    width: 41px;
    height: 58px;
    border: 1px solid black;
    background-repeat: no-repeat;
    background-size: auto 56px;
    transition: transform 0.2s; /* Animation */
  }

  .zoom {
    transform: scale(1.25);
  }

  div.commandButtons {
    display: grid;
    margin: auto;
    width: 218px;
    grid-template-columns: 100px 18px 100px;
  }

  div.commandButton {
    display: grid;
    width: 218;
    margin: auto;
    grid-template-columns: 59px 100px 59px;
  }

  button.commandButton {
    border: none;
    background-color: transparent;
    font-weight: bold;
    font-size: 12px;
  }

  @media (min-width: 700px) {
    .gridWrapper {
      width: 230px;
      height: 288px;
      grid-template-columns: 80px 80px 80px;
      grid-template-rows: 100px 100px 100px;
    }

    .container {
      width: 80px;
      height: 100px;
    }

    .hand-cards {
      width: 67px;
      height: 83px;
      background-size: auto 160px;
    }
    .hand-card-back {
      width: 67px;
      height: 83px;
    }

    .deckContainer {
      width: 200px;
      height: 120px;
      margin: 50px auto;
      grid-template-columns: 100px 20px 100px;
    }

    .decks {
      height: 120px;
    }

    .game-cell {
      width: 80px;
      height: 120px;
      background-size: auto 120px;
    }
  }
</style>

<script>
  import { getContext, onDestroy, onMount } from 'svelte'
  import { fade } from 'svelte/transition'
  import { getCardToPlay } from './CardToPlay/cardToPlay.js'
  import { checkForSeries, getHandValue, copyObject } from './services.js'
  import {
    playerHandClick,
    playerDiscardClick,
    playerDeckClick,
  } from './PlayerHand/playerHand.js'
  import { processComputerTurn } from './ComputerHand/ProcessComputerTurn.js'

  import {
    deck,
    hands,
    discard,
    player,
    computer,
    gameScore,
    updatePlayerHand,
    updateComputerHand,
    addToDiscard,
    updatePlayer,
    currentPlayer,
    removeFromDeck,
    updateGameScore,
    removeFromDiscard,
    topDiscard,
    saveUnfinishedGame,
    loadUnfinishedGame,
  } from '../stores/cards'

  import { get } from 'svelte/store'

  import {
    handOver,
    gameOver,
    endRound,
    cardsInitialized,
    clearStores,
    zoomDeck,
    _zoomDeck,
    zoomDiscard,
    _zoomDiscard,
    discardSelected,
    sourceCard,
    targetCard,
  } from '../stores/cardPLay'

  // Variables
  const ends = getContext('end')
  const endHand = ends.hand
  const nextHand = ends.nextHand
  const endGame = ends.game
  const nextGame = ends.nextGame

  const handleSave = getContext('saveConfig')

  export let speed
  export let gamePoints

  let computerHandSelected = false
  let playerHandSelected = true

  // let Player = 0
  let playerTurn = 0
  let computerPlayer = 1
  const goOutScore = 0

  let winner
  let firstEndRoundPlayer = 0

  const CL = console.log
  const CO = copyObject
  let HandNumber = 0
  let CW
  let points
  CW = speed
  points = gamePoints

  onMount(() => {
    if (loadUnfinishedGame()) {
      incrementTurn($currentPlayer)
    }
  })

  onDestroy(() => {
    if (!gameOver) {
      saveUnfinishedGame()
    }
  })

  // Screen functions
  function getGridClass(playerHand) {
    const turn = $currentPlayer === playerHand ? 'playerTurn' : 'notPlayerTurn'
    return `gridWrapper ${turn}`
  }

  function getUrl(card) {
    let name
    if (card.displayClass === 'visible') {
      name = card.name
    } else if (card.displayClass === 'hidden') {
      name = 'RedCardBack'
    }
    if (!card.name) console.log('getUrl', card)

    const urlString = `url('../assets/imgs/${name}.svg')`
    return urlString
  }

  function getClass(card) {
    let className
    if (card.displayClass === 'visible') {
      className = 'hand-cards'
    } else if (card.displayClass === 'hidden') {
      className = 'hand-card-back'
    }
    return className
  }

  function setDiscardBackground(card) {
    if (!card.name) console.log('setDiscardBackground', card)

    const urlString = `url('../assets/imgs/${card.name}.svg')`
    return urlString
  }

  // Play functions

  function getNextHand() {
    nextHand()
  }

  function discardClick() {
    if (cardsInitialized() < 2) return

    if (!sourceCard()) {
      // select discard as sourceCard
      discardSelected(true)
      sourceCard(topDiscard())
      zoomDiscard(true)
      return
    }

    if (discardSelected() && !targetCard()) {
      // if discard selected and no target, deselect discard
      discardSelected(false)
      sourceCard(null)
      return
    }

    playerDiscardClick()

    if (handOver()) {
      endRoundPlay($player, 0)
      wait()
      finalScore()
      wait()
    } else {
      if (allCardsRevealed($player)) {
        handOver(true)
      }
      clearStores()
      incrementTurn()
    }
  }

  async function incrementTurn(resumePlayer) {
    if (resumePlayer) {
      playerTurn = resumePlayer
    } else {
      playerTurn = $currentPlayer === 0 ? 1 : 0
      updatePlayer(playerTurn)
    }

    // Player = playerTurn
    if ($currentPlayer === computerPlayer) {
      computerHandSelected = true

      const params = {
        player: get(player),
        computer: get(computer),
        deck: get(deck),
        CW: CW,
        goOutScore: goOutScore,
        endRound: endRound(),
      }
      await processComputerTurn(params)

      if (handOver()) {
        endRoundPlay($computer, 1)
        wait()
        finalScore()
        wait()
      } else {
        if (allCardsRevealed($computer)) {
          handOver(true)
        }
      }
      clearStores()
      incrementTurn()
      playerHandSelected = true
    }
  }

  function endRoundPlay(hand, playerNumber) {
    const handHidden = hand.find(card => {
      return card.displayClass === 'hidden'
    })
    if (handHidden) {
      hand.forEach(card => {
        if ((playerNumber = 0)) {
          updatePlayerHand(card.index, card)
        } else {
          updateComputerHand(card.index, card)
        }
        checkForSeries(playerNumber, hand, card.handIndex)
      })
    }
  }

  function allCardsRevealed(hand) {
    const returnCard = hand.find(card => {
      return card.displayClass === 'hidden'
    })
    if (returnCard) {
      return false
    } else {
      return true
    }
  }

  function finalScore() {
    console.log('finalScore')
    const contestants = $gameScore
    const playerHand = getHandValue($player)
    const computerHand = getHandValue($computer)

    contestants.playerHand = playerHand
    contestants.computerHand = computerHand
    contestants.gamePlayer += playerHand
    contestants.gamecomputer += computerHand

    const scores = {
      playerHand: contestants.playerHand,
      computerHand: contestants.computerHand,
      gamePlayer: contestants.gamePlayer,
      gameComputer: contestants.computerPlayer,
    }
    if (points === '0') {
      console.log('points === 0, endGame', points)
      endHand(scores)
      endGame(scores)
    } else {
      console.log('points !== 0, endHand', points)
      endHand(scores)
      if (
        contestants.gamePlayer >= points ||
        contestants.gameComputer >= points
      ) {
        gameOver(true)
        endGame(scores)
      }
    }
  }

  async function wait(milliseconds = 1000) {
    return new Promise(resolve => {
      setTimeout(resolve, milliseconds)
    })
  }
</script>

<div class="game">
  <div style="padding: 3px">
    <div
      transition:fade="{{ delay: 250, duration: 300 }}"
      class="gridWrapper"
      class:playerTurn="{$currentPlayer === 1}"
    >
      {#each $computer as computerCard, index}
        <div class="container">
          <div
            class="{getClass(computerCard)}"
            class:zoom="{computerCard.zoom}"
            style="background-image: {getUrl(computerCard)}"
          ></div>
        </div>
      {/each}
    </div>
  </div>

  <div class="deckContainer">
    <div class="decks">
      <div
        class="game-cell"
        class:zoom="{$_zoomDeck}"
        style="background-image: {getUrl($deck[0])}"
        on:click="{() => playerDeckClick()}"
      ></div>
    </div>
    <div>&nbsp;</div>
    <div class="decks">
      <div
        class="game-cell"
        class:zoom="{$_zoomDiscard}"
        on:click="{() => discardClick()}"
        style="background-image: {setDiscardBackground($discard[0])}"
      ></div>
    </div>
  </div>

  <div style="padding: 3px">
    <div
      transition:fade="{{ delay: 250, duration: 300 }}"
      class="gridWrapper"
      class:playerTurn="{$currentPlayer === 0}"
    >
      {#each $player as playerCard, index}
        <div class="container">
          <div
            class="{getClass(playerCard)}"
            class:zoom="{playerCard.zoom}"
            style="background-image: {getUrl(playerCard)}"
            on:click="{() => playerHandClick(playerCard, index)}"
          ></div>
        </div>
      {/each}
    </div>
  </div>
  {#if true}
    <div class="commandButtons">
      <button class="commandButton" on:click="{getNextHand}">Next Hand</button>
      <div>&nbsp;</div>
      <button class="commandButton" on:click="{nextGame}">New Game</button>
    </div>
  {:else}
    <div class="commandButton">
      <div>&nbsp;</div>
      <button class="commandButton" on:click="{nextGame}">New Game</button>
      <div>&nbsp;</div>
    </div>
  {/if}
</div>
